import axios from "../utils/axios";

class AuthService{
    login(data){
        return axios.post("login", data);
    }
    forgotPassword(data){
        return axios.post("forgot-password", data);
    }
    validateResetToken(token){
        return axios.get("validate-reset-token", { params: { token } });
    }
    resetPassword(data){
        return axios.post("reset-password", data);
    }
}
export const getCurrentUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }; 
export default new AuthService();
